<div class="custom-card-placeholder" *cdkDragPlaceholder></div>
<mat-card
  appearance="outlined"
  class="opportunity-card isSelected"
  [class.isSelected]="isSelectedOpportunity$ | async"
  (click)="selected()"
>
  <div class="card-content">
    <uikit-async-ui [loading]="nameLoading$ | async" [data]="businessName$ | async">
      <ng-container *successData="let businessName">
        <span *ngIf="businessName === ''; else businessFound" class="business-not-found">
          {{ 'FRONTEND.SALES_UI.PIPELINE.ACCOUNT_LOAD_FAILED' | translate }}
        </span>
        <ng-template #businessFound>
          <a (click)="openDetails(opportunity, $event)">
            {{ businessName }}
          </a>
        </ng-template>
      </ng-container>
    </uikit-async-ui>
    <div class="opportunity-name">
      {{ opportunity.name }}
    </div>
    <div class="opportunity-card__details">
      <span class="card-revenue">
        {{ opportunity.projectedFirstYearValue || 0 | formatCurrency: (currency$ | async) }}
      </span>
      <ng-container>
        <va-icon
          *ngIf="salesperson$ | async as salesperson"
          [iconName]="salesperson.fullName"
          [iconUrl]="salesperson.pictureServingUrl"
          diameter="32"
          class="salesperson-image"
          [matTooltip]="salesperson.fullName"
        ></va-icon>
      </ng-container>
    </div>

    <ng-container *ngIf="sortSelection$ | async as option">
      <div class="subtitle" *ngIf="option.lastSalesActivity">
        {{ 'FRONTEND.SALES_UI.PIPELINE.COLUMN_LABELS.LAST_ACTIVITY' | translate }}:
        {{ getDateOrNull(opportunity.lastActivityDate) || 'FRONTEND.SALES_UI.COMMON.NONE_LABEL' | translate }}
      </div>
      <div class="subtitle" *ngIf="option.lastConnected">
        {{ 'FRONTEND.SALES_UI.PIPELINE.COLUMN_LABELS.LAST_CONNECTED' | translate }}:
        {{ getDateOrNull(opportunity.lastConnectedDate) || 'FRONTEND.SALES_UI.COMMON.NONE_LABEL' | translate }}
      </div>
      <div class="subtitle" *ngIf="option.expectedCloseDate">
        {{ 'FRONTEND.SALES_UI.PIPELINE.COLUMN_LABELS.EXPECTED_CLOSE' | translate }}:
        {{ getDateOrNull(opportunity.expectedCloseDate) || 'FRONTEND.SALES_UI.COMMON.NONE_LABEL' | translate }}
      </div>
      <div class="subtitle" *ngIf="option.actualCloseDate">
        {{ 'FRONTEND.SALES_UI.PIPELINE.COLUMN_LABELS.ACTUAL_CLOSE' | translate }}:
        {{ getDateOrNull(opportunity.actualClosedDate) || 'FRONTEND.SALES_UI.COMMON.NONE_LABEL' | translate }}
      </div>
      <div class="subtitle" *ngIf="option.createdDate">
        {{ 'FRONTEND.SALES_UI.PIPELINE.COLUMN_LABELS.CREATED_DATE' | translate }}:
        {{ getDateOrNull(opportunity.created) || 'FRONTEND.SALES_UI.COMMON.NONE_LABEL' | translate }}
      </div>
      <div class="subtitle" *ngIf="option.assignedDate">
        {{ 'FRONTEND.SALES_UI.PIPELINE.COLUMN_LABELS.ASSIGNED' | translate }}:
        {{ getDateOrNull(opportunity.assignedDate) || 'FRONTEND.SALES_UI.COMMON.NONE_LABEL' | translate }}
      </div>
      <div *ngIf="meddicScore > 0">
        <div class="subtitle">{{ 'FRONTEND.SALES_UI.PIPELINE.COLUMN_LABELS.QUALIFICATION' | translate }}:</div>
        <sales-ui-meddic-progress-bar
          class="qualification-progress-bar"
          [loading]="MEDDICScoresLoading$ | async"
          [scores]="MEDDICScores$ | async"
        ></sales-ui-meddic-progress-bar>
      </div>
    </ng-container>
  </div>
</mat-card>
